import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import blackWhiteIcon from 'src/public/img/illustartion-choice.svg';
import conclusionsIcon from 'src/public/img/illustartion-conclusion.svg';
import thinkingIcon from 'src/public/img/illustration-emotional-distress.svg';
import emotionalIcon from 'src/public/img/illustration-goals.svg';

import { TipCard } from 'src/modules/programs/components/TipCard';
import * as S from 'src/modules/programs/stepComponents/styles';

const unhelpfulThoughtsIcons = [thinkingIcon, conclusionsIcon, blackWhiteIcon, emotionalIcon];

interface UnhelpfulThoughts {
    title: string;
    icon: string;
    descriptions: string[];
}

export const ThoughtsCanBeUnhelpfulStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const unhelpfulThoughts: UnhelpfulThoughts[] = t(
        'week-5.thoughts-can-be-unhelpful.unhelpfulThoughts',
        { returnObjects: true },
    );

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading>{t('week-5.thoughts-can-be-unhelpful.title')}</S.StepHeading>
                    <S.StepDescription small>
                        {t('week-5.thoughts-can-be-unhelpful.description')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow type="flex">
                {unhelpfulThoughts.map((thought, index: number) => (
                    <TipCard
                        key={thought.title}
                        iconUrl={unhelpfulThoughtsIcons[index]}
                        title={thought.title}
                        children={thought.descriptions.map(description => (
                            <S.StepDescription small key={description}>
                                {description}
                            </S.StepDescription>
                        ))}
                    />
                ))}
            </S.ContentRow>
        </>
    );
});
